

import React, {useState} from 'react'
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { Box, Typography, Grid, Button } from '@mui/material';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {Alert, TableCustom} from 'components/common';
import InventoryGroupModal from "./InventoryGroupModal";

export const InventoryGroup = ({ methods, policies, hosts, items,soloVer }) => {

  const [t] = useTranslation();
  const { getValues, setValue, control, watch} = methods;
  const [openModal, setOpenModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [indexHostGroupEdit, setIndexHostGroupEdit] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [defaultValues, setDefaultValues] = useState({
    modalGroupName: '',
    modalGroupDescription: '',
    modalTags: [],
    modalGroupHosts: [],
    modalNetworkType: '',
    modalVariables : '',
    language: 'ini'
  });
  const theme = useTheme();

  const watchHostField = watch(policies.hosts.name, []);

  const onSubmitCreate = (data) => {
    const groupHosts = [...getValues(policies.hostGroups.name), data];
    setValue(policies.hostGroups.name, groupHosts);
    handleCloseModal();
  };

  const onSubmitEdit = (data) => {
    const groups = getValues(policies.hostGroups.name).map((h,i) => {
      if (i === data.index) {
        return {
          name: data.name,
          description: data.description,
          tags: data.tags,
          hosts: data.hosts,
          networkType: data.networkType,
          variables: data.variables,
          variablesType: data.variablesType,
          hostToShow: data.hosts.map(host => host.label).join(',')
        }
      } else return h
    });
    setValue(policies.hostGroups.name, groups);
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAdd = (data) => {
    setDefaultValues({
      modalGroupName: '',
      modalGroupDescription: '',
      modalTags: [],
      modalGroupHosts: [],
      modalNetworkType: '',
      modalVariables : '',
      language: 'json'
    });
    setIsEdit(false);
    setOpenModal(true);
  };

  const handleDelete = (item) => {
    const childs = getValues(policies.childrenGroups.name);
    const childrenThatUseGroup = childs.map(g => {
      const groupFound = g.hostGroups.map(h => item.name === h.name);
      return (groupFound) ? 'yes' : 'no';
    })
    if (childrenThatUseGroup.includes('yes')) {
      setShowAlert(true);
    } else {
      const items = getValues(policies.hostGroups.name);
      setValue(
        policies.hostGroups.name,
        items.filter(i => i.name !== item.name)
      );
    }
  };

  const handleEdit = (item) => {

    setDefaultValues({
      modalGroupName        :item.name,
      modalGroupDescription :item.description,
      modalTags             :item.tags,
      modalGroupHosts       :item.hosts,
      modalNetworkType      :item.networkType,
      modalVariables        :item.variables,
      language              :item.variablesType
    });

    const items = getValues(policies.hostGroups.name);
    const indexHost = items.findIndex(h => h.name === item.name);
    setIndexHostGroupEdit(indexHost);
    setIsEdit(true);
    setOpenModal(true);
  };

  const columns = [
    { label: t('inventoryList.groupHosts.table.columns.name'), key: 'name' },
    { label: t('inventoryList.groupHosts.table.columns.hosts'), key: 'hostToShow' },
  ];

  const actions = [
    {
      label: t('inventoryList.groupHosts.table.actions.edit'),
      icon: <EditOutlinedIcon color='primary'/>,
      handle: handleEdit
    },
    {
      label: t('inventoryList.groupHosts.table.actions.delete'),
      icon: <HighlightOffIcon color='primary'/>,
      handle: handleDelete
    }
  ];

  const disableAddGroups = () => {
    const items = getValues(policies.hosts.name);
    return items.length <= 0
  }

  const handleCloseAlert = () => {
    setShowAlert(false);
  }

  return (
    <>
    <Box sx={{ overflow: 'hidden' }}>
        <Grid container spacing={2} alignItems="center" sx={{ pt: 1 }}>
          <Grid item xs={12} sm={4} md={4} lg={4} sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 3
          }}>
            <Typography variant="h6" sx={{ padding: '4px 0px' }}>
              {t('inventoryList.groupHosts.title')}
            </Typography>
            {!soloVer?<Button variant="contained" onClick={handleAdd} type="button" disabled={!watchHostField.length}>
              {t('inventoryList.groupHosts.button')}
            </Button>:null}
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box
              sx={{
                border: `1px solid ${theme.palette.grey[400]}`,
                borderRadius: 1,
                overflow: 'hidden',
              }}
            >
              <Controller
                control={control}
                name={policies.hostGroups.name}
                id={policies.hostGroups.id}
                render={({ field: { value } }) => (
                  <TableCustom
                    columns={columns}
                    content={value}
                    actions={actions}
                    config={{
                      notResults: {
                        disabledIcon: true,
                        title: 'inventoryList.groupHosts.table.title',
                        description: 'inventoryList.groupHosts.table.description',
                        size: '20vh'
                      }
                    }}
                  />
                )}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      { openModal &&
        <InventoryGroupModal
          open={openModal}
          handleClose={handleCloseModal}
          onSubmitCreate={onSubmitCreate}
          onSubmitEdit={onSubmitEdit}
          defaultValues={defaultValues}
          isEdit={isEdit}
          policies={policies}
          items={getValues(policies.hostGroups.name)}
          currentHosts={getValues(policies.hosts.name)}
          index={indexHostGroupEdit}
        />
      }
      <Alert severity="error"
             handleClose={handleCloseAlert}
             open={showAlert}
             message="inventoryList.groupHosts.error.groupDelete"
      />
    </>
  )
}
